// extracted by mini-css-extract-plugin
export var boldText = "_6q-4";
export var checkboxContainer = "_6q-6";
export var closeIcon = "_6q-i";
export var container = "_6q-0";
export var drawer = "_6q-8";
export var drawerContent = "_6q-9";
export var extraSmallText = "_6q-5";
export var fulfillmentGroupTable = "_6q-e";
export var largeText = "_6q-3";
export var loadingSpinnerContainer = "_6q-j";
export var mediumText = "_6q-2";
export var narrow = "_6q-f";
export var notificationLink = "_6q-l";
export var packageCheckIconContainer = "_6q-7";
export var slideoutHeaderActions = "_6q-g";
export var slideoutHeaderActionsShifted = "_6q-h";
export var slideoutHeaderContainer = "_6q-a";
export var slideoutModal = "_6q-c";
export var stickyHeaderWrapper = "_6q-b";
export var table = "_6q-k";
export var tableContainer = "_6q-d";
export var tertiaryText = "_6q-1";